// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Alexander Mikholap <alexander.mikholap@celadon.ae>

export const getPrice = (activeDiscountCode, total, isVoucher) => {
  const voucher = isVoucher ? 1.1 : 1;
  const price = (total.price * voucher);
  if (Object.keys(activeDiscountCode).length) {
    if (activeDiscountCode.DiscountType === 1) {
      return (price + (total.price * activeDiscountCode.Value / 100));
    }
    if (activeDiscountCode.DiscountType === 2) {
      return (price + activeDiscountCode.Value);
    }
  }
  return price;
};
